import { NavBar } from '../../MainLayout/NavBar'
import { PatientAlertsBanner, PatientMergeBanner } from '../../../patient'
import { PatientPageHeader } from './PatientPageHeader'
import { useCurrentPatient, useGoBack } from '../../../../hooks/utils'

export const PatientPageNavBar = () => {
  const { currentPatient: patient } = useCurrentPatient()
  // The timeline is reached from the patient list, from the tasks, from a search...: go back where
  // we actually came from
  const goBack = useGoBack('/patients')

  if (!patient) {
    return <NavBar onBackButtonClick={goBack}>Chargement...</NavBar>
  }

  return (
    <NavBar
      onBackButtonClick={goBack}
      keepSearchParams={false}
      // the destination depends on where we came from: no more promising the patient list
      backButtonTitle="Retour"
      stickyHeaderContent={
        <>
          <PatientMergeBanner patient={patient} />
          <PatientAlertsBanner />
        </>
      }
    >
      <PatientPageHeader patient={patient} />
    </NavBar>
  )
}
